import { IDlsVersionMeta } from './define-versions';

const warned = new Set<string>();

const warnOnce = (key: string, message: string): void => {
  // eslint-disable-next-line no-process-env
  if (process.env.NODE_ENV === 'production' || warned.has(key)) return;
  warned.add(key);
  // eslint-disable-next-line no-console
  console.warn(message);
};

/**
 * Dev-only deprecation pressure: warns (once per component+version+kind) when
 * a component renders its previous version — whether requested explicitly via
 * `v` or reached implicitly because the component's `default` still points at
 * it.
 */
export const warnDeprecated = (
  meta: IDlsVersionMeta,
  version: string,
  explicitV?: string
): void => {
  if (version === meta.previous) {
    if (explicitV === version) {
      warnOnce(
        `${meta.component}:${version}:explicit`,
        `[DLS] <${meta.component} v="${version}"> is deprecated — migrate to ${meta.current}.`
      );
    } else {
      warnOnce(
        `${meta.component}:${version}:default`,
        `[DLS] <${meta.component}> currently defaults to deprecated version ${version} — pass v="${meta.current}" or flip the component's default.`
      );
    }
  }
};
